import React, { Component } from 'react';
import { connect } from 'react-redux';
import PermissionButton from 'components/elements/common/permission/PermissionButton';
import { fetchAndDownloadPhoto } from 'store/actions/photos';
import { downloadLegacyVideo } from 'store/actions/videos';
import ErrorView from 'elements/common/ErrorView';
import { ASSET_TYPES } from '../../../../utils/constants';

class AttachmentDownload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  toggleOpen() {
    this.setState(({ open }) => ({ open: !open }));
  }

  downloadWatermark() {
    const { attachment: { id, watermark: thumb, width, height }, downloadImage } = this.props;
    downloadImage(id, thumb, true, width > height);
  }

  downloadImage() {
    const { attachment: { id, url: thumb }, downloadImage } = this.props;
    downloadImage(id, thumb, false);
  }

  downloadSvgImage() {
    const { attachment: { id, svgFile }, downloadImage } = this.props;
    downloadImage(id, svgFile, false);
  }

  downloadVideo() {
    const { attachment: { id, contentLocation }, downloadVideo: download } = this.props;
    download(id, contentLocation);
  }

  render() {
    const { revision, attachment: { type, svgFile }, videoError, photoError } = this.props;
    if (type === ASSET_TYPES.video.type) {
      return (
        <div className={`news--download ${type}`}>
          <PermissionButton permission={`news.${revision}.${type}.download`} className="news--download__toggle" onClick={() => this.downloadVideo()} ariaLabel={`Download ${type} ${revision}`} />
          {videoError && <ErrorView className="news-error video-download-error" error={videoError} />}
        </div>
      );
    }
    const { open } = this.state;
    return (
      <div className={`news--download ${type}`}>
        <button type="button" className="news--download__toggle" onClick={() => this.toggleOpen()} aria-label={`Download ${type} ${revision}`} />
        <div className={`news--download__options ${open ? '' : 'hide'}`}>
          <PermissionButton permission={`news.${revision}.${type}.watermark`} mediaType={type} className="news--download__low-res" onClick={() => this.downloadWatermark()}>Low Resolution</PermissionButton>
          <PermissionButton permission={`news.${revision}.${type}.download`} mediaType={type} className="news--download__high-res" onClick={() => this.downloadImage()}>High Resolution</PermissionButton>
          {svgFile && <PermissionButton permission={`news.${revision}.${type}.download`} mediaType={type} className="news--download__svg" onClick={() => this.downloadSvgImage()}>High Resolution (SVG)</PermissionButton>}
          {photoError && <ErrorView className="news-error photo-download-error" error={photoError} />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ videos, photos }) => ({
  videoError: videos.error,
  photoError: photos.error,
});

const mapDispatchToProps = {
  downloadImage: fetchAndDownloadPhoto,
  downloadVideo: downloadLegacyVideo,
};

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentDownload);
